/**
 * Maps DSA URLs to assessment_tab_view (no raw SFIDs or correlation ids in params).
 */
import { trackEvent } from './analytics';

const INTERNAL_REST = /^\/account\/[^/]+\/dsa\/[^/]+\/(.+)$/;
const PARTNER_REST = /^\/dsa\/account\/[^/]+\/assessment\/[^/]+\/(.+)$/;

function parseRest(rest, flow) {
  const parts = rest.split('/').filter(Boolean);
  if (parts.length === 0) {
    return null;
  }
  const head = parts[0];
  if (head === 'sources' || head === 'usage' || head === 'goals') {
    return {
      main_tab: head,
      sub_tab: parts[1] ? 'area' : 'index',
      flow
    };
  }
  if (head === 'correlations') {
    return {
      main_tab: 'correlations',
      sub_tab: parts[1] ? 'detail' : 'index',
      flow
    };
  }
  if (head === 'analytics') {
    const sub = parts[1] || 'index';
    return {
      main_tab: 'analytics',
      sub_tab: sub,
      flow,
      has_route_suffix: parts.length > 2
    };
  }
  if (head === 'pptx' && parts[1] === 'preview') {
    return {
      main_tab: 'pptx_preview',
      sub_tab: parts[2] || 'index',
      flow
    };
  }
  return null;
}

/**
 * @param {string} pathname — location.pathname only
 * @param {string|undefined} assessmentType — from Redux when loaded
 */
export function trackDsaAssessmentNavigation(pathname, assessmentType) {
  const path = pathname || '';
  let flow = 'internal';
  let m = path.match(INTERNAL_REST);
  if (!m) {
    m = path.match(PARTNER_REST);
    flow = 'partner';
  }
  if (!m) {
    return;
  }
  const parsed = parseRest(m[1], flow);
  if (!parsed) {
    return;
  }
  const payload = Object.assign({ tool: 'dsa' }, parsed);
  if (assessmentType) {
    payload.assessment_type = assessmentType;
  }
  trackEvent('assessment_tab_view', payload);
}



// WEBPACK FOOTER //
// ./src/utils/dsaRouteAnalytics.js